import { QueryObserverOptions } from '@tanstack/react-query'

import config from '../../config'
import { buildGetQuery } from '../../util'

import { ISafetyCase, IGetRequestObject } from '../../interfaces'

type Params = {
  id: number
}

const getSafetyCaseByIdQueryRequest = (params: Params): IGetRequestObject => {
  const { id } = params

  return {
    method: 'get',
    url: `${config.baseUrl}/sms/SafetyCases/${id}`,
  }
}

const useSafetyCaseByIdQueryBase = buildGetQuery<Params, undefined, ISafetyCase | undefined>({
  getRequest: getSafetyCaseByIdQueryRequest,
  getQueryKey: params => ['safety-case-by-id', params.id],
  defaultOptions: { initialData: undefined },
})

const useSafetyCaseByIdQuery = (params: Params, options?: QueryObserverOptions<ISafetyCase | undefined, Error>) =>
  useSafetyCaseByIdQueryBase(params, undefined, options)

export default useSafetyCaseByIdQuery
